import { _ as _define_property } from "@swc/helpers/_/_define_property";
export var EmailOnBehalfTypes = /*#__PURE__*/ function(EmailOnBehalfTypes) {
    EmailOnBehalfTypes["Sendgrid"] = "sendgrid";
    EmailOnBehalfTypes["Gmail"] = "gmail";
    EmailOnBehalfTypes["Outlook"] = "outlook";
    return EmailOnBehalfTypes;
}({});
export class EmailOnBehalfSettingsModel {
    static fromDTO(dto) {
        if (dto.provider === "sendgrid") {
            return new EmailOnBehalfSettingsModel({
                provider: "sendgrid",
                email: 'system@notifications.sayanchor.com'
            });
        } else if (dto.provider === "gmail") {
            return new EmailOnBehalfSettingsModel({
                provider: "gmail",
                email: dto.email
            });
        } else {
            return new EmailOnBehalfSettingsModel({
                provider: "outlook",
                email: dto.email
            });
        }
    }
    static makeDisconnected() {
        return EmailOnBehalfSettingsModel.fromDTO({
            provider: "sendgrid",
            email: null
        });
    }
    email() {
        return this.data.email;
    }
    provider() {
        if (this.data.provider !== "sendgrid") {
            return this.data.provider;
        }
        return null;
    }
    isDisconnected() {
        return this.data.provider === "sendgrid";
    }
    constructor(data){
        _define_property(this, "data", void 0);
        this.data = data;
    }
}
